// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@keller/Overrides/Widgets/Header/SearchInput";
import color from "@keller/XDL/Utilities/color";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";

searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            border: 1px solid ${color("common.ui2")};
            background-color: ${color("common.white")};
            box-shadow: 0 2px 4px 0 ${color("common.ui15", 0.25)};
            border-radius: 0;
            padding: 0;

            ${xScreen("lte", "md")} {
                border: none;
                box-shadow: unset;
                padding: 0;
                width: 100%;
                max-height: fit-content;
                height: calc(100vh - ${({ headerHeight }: any) => headerHeight ?? 152}px - 56px);
            }

            ${xScreen("lte", "sm")} {
                max-height: fit-content;
                transform: translate(0, ${({ offset }: any) => offset ?? 152}px) !important;
            }

            ${xScreen("lte", "xs")} {
                height: calc(100vh - ${({ headerHeight }: any) => headerHeight ?? 152}px + 56px);
            }
        `,
    },
    tooltipInnerContent: {
        css: css`
            ${xScreen("lte", "sm")} {
                scrollbar-gutter: stable;
                height: calc(100% - ${({ headerHeight }: any) => headerHeight ?? 152}px);
                max-height: fit-content;
            }
        `,
    },
};
